import { useGetMachineTokenQuery } from '@/store/services/identityApi';
import config from 'config';
import useWebSocket from 'react-use-websocket';

const useAnalyticsSocket = () => {
  const { data: machineToken } = useGetMachineTokenQuery();
  const { sendJsonMessage } = useWebSocket(
    config.analyticsSocket,
    {
      share: true,
      queryParams: {
        'x-socket-client': 'web',
        authorization: machineToken ?? '',
      },
      reconnectAttempts: 5,
      shouldReconnect: () => true,
    },
    !!machineToken
  );

  return {
    sendMessage: sendJsonMessage,
  };
};

export default useAnalyticsSocket;
